import { render, staticRenderFns } from "./previewCourse.vue?vue&type=template&id=3df74438"
import script from "./previewCourse.vue?vue&type=script&lang=js"
export * from "./previewCourse.vue?vue&type=script&lang=js"
import style0 from "./previewCourse.vue?vue&type=style&index=0&id=3df74438&prod&lang=less"
import style1 from "./previewCourse.vue?vue&type=style&index=1&id=3df74438&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports